import React from "react"
import style from "./bundle-savings.mod.scss"
import { CurrencyFormatter } from "@context/productContext"

/**
 * Savings currently shown by the Price element for the same product/variant.
 * Aggregate pricing displays "Save up to" (saveUpTo), single pricing "Save" (save).
 */
const getPriceSavings = (prices, isAggregate) => {
  if (!prices) return 0

  const value = Number(isAggregate ? prices.saveUpTo : prices.save)

  return Number.isFinite(value) && value > 0 ? value : 0
}

const hasValue = value =>
  value !== null &&
  value !== undefined &&
  value !== "" &&
  Number.isFinite(Number(value)) &&
  Number(value) > 0

/**
 * Combined savings figure: the bundle savings set in DatoCMS added to the
 * sale savings already shown against the current variant.
 */
const BundleSavings = ({
  bundlePriceSavings,
  prices,
  isAggregate = false,
  modifier = ""
}) => {
  if (!hasValue(bundlePriceSavings)) return null

  const total =
    Number(bundlePriceSavings) + getPriceSavings(prices, isAggregate)
  const modifiers = []

  modifier && modifiers.push(style[`bundle-savings--${modifier}`])

  return (
    <dl className={[style["bundle-savings"], ...modifiers].join(" ")}>
      <dt>
        {isAggregate ? "Bundle Price Savings up to" : "Bundle Price Savings"}
      </dt>
      <dd>
        <CurrencyFormatter value={total} />
      </dd>
    </dl>
  )
}

export default BundleSavings
